import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
// Polled every 10s while the page is open so the "last successful backup"
// timestamp updates without manual refresh after a "Run now" click. SSE
// would be nicer but this page is rarely open — polling is cheaper to
// implement.
export function useMetaBackupConfig() {
    return useQuery({
        queryKey: ['meta-backup', 'config'],
        queryFn: () => api('/system/meta-backup'),
        refetchInterval: 10_000,
        refetchIntervalInBackground: false,
    });
}
export function useUpdateMetaBackup() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (patch) => api('/system/meta-backup', {
            method: 'PATCH',
            body: JSON.stringify(patch),
        }),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['meta-backup'] });
        },
    });
}
export function useTestMetaBackup() {
    return useMutation({
        mutationFn: () => api('/system/meta-backup/test', { method: 'POST' }),
    });
}
export function useRunMetaBackupNow() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: () => api('/system/meta-backup/run-now', { method: 'POST' }),
        onSuccess: () => {
            // Invalidate after a short delay — task runs async, the row won't
            // exist for a couple seconds. The 10s poll picks up the rest.
            window.setTimeout(() => qc.invalidateQueries({ queryKey: ['meta-backup'] }), 3000);
        },
    });
}
